// extracted by mini-css-extract-plugin
export var brand = "_19-8";
export var compact = "_19-5";
export var extraSmall = "_19-6";
export var icon = "_19-0";
export var large = "_19-3";
export var light = "_19-1";
export var medium = "_19-4";
export var outline = "_19-a";
export var primaryDark = "_19-9";
export var primaryLight = "_19-7";
export var primaryModern = "_19-b";
export var success = "_19-2";